/**
 * Client Navigation
 * Handles smooth scrolling to specific clients when coming from anchor links
 */

export function initClientNavigation() {
    // Check if we're on the clients page and have a hash
    if (window.location.pathname.includes('nos-clients') && window.location.hash) {
        const targetId = window.location.hash.substring(1); // Remove the #
        const targetElement = document.getElementById(targetId);
        
        if (targetElement) {
            // Wait a bit for the page to fully load
            setTimeout(() => {
                // Smooth scroll to the target element
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
                
                // Add a highlight effect
                targetElement.classList.add('client-highlighted');
                
                // Remove highlight after animation
                setTimeout(() => {
                    targetElement.classList.remove('client-highlighted');
                }, 2000);
            }, 100);
        }
    }
    
    // Handle clicks on client cards in homepage
    const clientCards = document.querySelectorAll('.acc_clients-card');
    clientCards.forEach(card => {
        card.addEventListener('click', function(e) {
            // Let the default link behavior handle navigation
            // The smooth scrolling will be handled on the target page
        });
    });
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initClientNavigation);